import React, { useState } from 'react';
import {
  Box,
  Container,
  Stack,
  Typography,
  Link,
  IconButton,
  Fab,
  Zoom,
  useScrollTrigger,
  Menu,
  MenuItem,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TranslateIcon from '@mui/icons-material/Translate';
import { useTranslation } from 'react-i18next';
import { LandingNavbar } from './LandingNavbar';
import Footer from './Footer';

const brand = {
  primary: '#800b33',
  dark: '#5c0620',
  slate: '#1d1320',
};

const ScrollToTop = () => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 300,
  });

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Zoom in={trigger}>
      <Box
        role="presentation"
        sx={{ position: 'fixed', bottom: 32, right: 32, zIndex: 100 }}
      >
        <Fab
          onClick={handleClick}
          size="medium"
          aria-label="scroll back to top"
          sx={{
            bgcolor: brand.primary,
            color: '#fff',
            '&:hover': { bgcolor: brand.dark },
            boxShadow: '0 10px 20px rgba(128,11,51,0.3)',
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Box>
    </Zoom>
  );
};

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (lng) => {
    if (lng && i18n) {
      i18n.changeLanguage(lng);
    }
    setAnchorEl(null);
  };

  return (
    <Box sx={{ position: 'fixed', top: 12, right: 100, zIndex: 1200 }}>
      <IconButton
        onClick={handleClick}
        sx={{
          bgcolor: 'rgba(255,255,255,0.8)',
          backdropFilter: 'blur(4px)',
          color: brand.primary,
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          '&:hover': { bgcolor: '#fff' },
        }}
      >
        <TranslateIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose()}>
        <MenuItem onClick={() => handleClose('en')}>English</MenuItem>
        <MenuItem onClick={() => handleClose('sw')}>Kiswahili</MenuItem>
      </Menu>
    </Box>
  );
};

export const LandingLayout = ({ children }) => {
  return (
    <Box sx={{ minHeight: '100vh', background: '#fff' }}>
      <LandingNavbar />
      {children}
      <Footer />
      <ScrollToTop />
      <LanguageSwitcher />
    </Box>
  );
};

